import { render } from "./nav-bar-fw.vue?vue&type=template&id=2be8e28a"
import script from "./nav-bar-fw.vue?vue&type=script&lang=js"
export * from "./nav-bar-fw.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__